import React from 'react';
import { useSelector } from 'react-redux';
import LiveQuizPage from './LiveQuizPage';
import InviteLink from '../InviteGuests';
import './livequizpage.css';

const Stereocentergame = () => {
  const userDetails = useSelector((state) => state.userDetails);
  const user = userDetails?.user;

  // Derive the room number from user id
  const roomNumber = user ? user.id * 35 : null;

  if (!user) {
    return (
      <div className="outer-quiz-container">
        <div className="message">
          <h3>Error: User must be logged in to host a quiz!</h3>
          <p>Please sign in to continue.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="outer-quiz-container">
      <div className="game-intro-section">
        <div className="intro-header">
          <h1>Stereochemistry Challenge</h1>
          <div className="intro-tagline">Test your knowledge of chiral centers, R/S configuration, and stereoisomerism</div>
        </div>
        
        <div className="intro-card">
          <div className="intro-card-header">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 8V12" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="16" r="1" fill="#3498db"/>
            </svg>
            <h2>How to Play</h2>
          </div>
          
          <div className="intro-card-content">
            <p>Welcome to the Stereochemistry Challenge! Test your ability to identify and assign configurations to chiral centers in an exciting, interactive format.</p>
            
            <div className="intro-steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-text">The host starts the game focused on organic chemistry stereochemistry.</div>
              </div>
              
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-text">Participants will join the game using a unique room code provided by the host.</div>
              </div>
              
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-text">Each question will display a molecule with a chiral center, and players must identify its correct stereochemistry.</div>
              </div>
              
              <div className="step">
                <div className="step-number">4</div>
                <div className="step-text">You'll need to determine R/S configurations, identify meso compounds, and recognize enantiomers and diastereomers.</div>
              </div>
              
              <div className="step">
                <div className="step-number">5</div>
                <div className="step-text">Points are awarded based on accuracy and speed. The faster you answer correctly, the more points you earn!</div>
              </div>
              
              <div className="step">
                <div className="step-number">6</div>
                <div className="step-text">At the end of the game, the player with the highest score wins!</div>
              </div>
            </div>
            
            <div className="intro-card-footer">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L19.0711 6.5V15.5L12 20L4.92893 15.5V6.5L12 2Z" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 20V15.5" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M19.0711 6.5L12 11L4.92896 6.5" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 2V6.5" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 11V15.5" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <p>Good luck, and may the best stereochemist win!</p>
            </div>
          </div>
        </div>
        
        <div className="invite-section">
          <h3>Invite Players</h3>
          <p>Share the room code with other participants to join this quiz session</p>
          <InviteLink roomNumber={roomNumber} topics={[63]} />
        </div>
      </div>
      
      <div className="game-container">
        <LiveQuizPage topics={63} roomNumber={roomNumber} />
      </div>
    </div>
  );
};

export default Stereocentergame;
